<template>
  <div class="visit-box">
    <crumb-tit>
      <span slot="breadTit">线索配置</span>
      <span slot="secondTit">线索配置</span>
    </crumb-tit>
    <div
      v-if="loadingContent"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <template v-else>
      <div
        class="clue-alert"
      >
        <a-alert
          message="开启线索管理功能"
          type="info"
        >
          <div slot="description">
            线索管理适用于管理内容不完整，不适合录入并分配给销售跟进，需要其他角色（信息开发或者信息接待）进行简单初步跟进的信息。
            <div class="clue-switch">
              <a-switch
                :checked="!!datas.isopen"
                @change="openHandle"
              />
              <span class="open-txt">{{ !!datas.isopen ? '已开启': '已关闭' }}</span>
            </div>
          </div>
        </a-alert>
      </div>
      <div
        class="visit-form"
      >
        <a-form
          :form="form"
          :hide-required-mark="true"
          @submit.prevent="saveForm"
        >
          <div class="clue-item-box">
            <h2 class="clue-item-tit">
              线索分配
            </h2>
            <div class="clue-item-con">
              <a-form-item
                label=""
                class="clue-distribute"
              >
                <a-radio-group
                  name="radioGroup"
                  :value="datas.assign"
                  @change="getAssgin"
                >
                  <a-radio :value="1">
                    分配给录入人员
                  </a-radio>
                  <a-radio :value="2">
                    分配给 <a-form-item>
                      <a-cascader
                        v-if="datas.assign * 1 === 2"
                        v-decorator="[
                          'useid',
                          { rules: [{ required: true, message: '请选择' }], initialValue: teamValue},
                        ]"
                        :field-names="{ label: 'name', value: 'id', children: 'children' }"
                        :options="teamDatas"
                        placeholder="请选择"
                        @change="handleChange"
                      />
                      <a-cascader
                        v-else
                        v-decorator="[
                          'id',
                          { initialValue: teamValue},
                        ]"
                        :field-names="{ label: 'name', value: 'id', children: 'children' }"
                        :options="teamDatas"
                        placeholder="请选择"
                        @change="handleChange"
                      />
                    </a-form-item>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
          </div>
          <div class="clue-item-box set-clue-item">
            <h2 class="clue-item-tit">
              线索跟进
            </h2>
            <div
              class="clue-alert clue-alert2"
            >
              <a-alert
                message=""
                type="info"
              >
                <div slot="description">
                  <i class="iconfont iconicon-test34" />
                  可设置线索跟进字段，针对跟进字段创建跟进任务；可拖动排序，调整跟进字段的优先级；如果不设置跟进字段， 可针对整条线索创建跟进任务。
                  可设置线索无效条件，当线索符合所有设置的线索无效条件后，自动将线索状态修改为无效，或者标记为疑似无效。
                </div>
              </a-alert>
            </div>
            <div class="follow-time-set">
              <a-form-item
                label="跟进提醒："
              >
                每天
                <a-time-picker
                  v-decorator="['sendtime', {
                    rules: [{ type: 'object', required: true, message: '请选择时间' }],
                    initialValue: $moment(datas.sendtime, 'HH:mm')
                  }]"
                  style="width: 160px;margin:0 8px;"
                  format="HH:mm"
                  @change="getTime"
                />
                发送
              </a-form-item>
            </div>

            <div class="clue-item-con clue-fields-set-box">
              <draggable
                v-if="datas['followup_field'].length"
                v-model="datas['followup_field']"
                :options="{
                  animation: 60,
                  handle:'.draggable-item-icon'
                }"
              >
                <form-item
                  v-for="(item, index) in datas['followup_field']"
                  :key="item.fieldkey || index+'fields'"
                  :index="index"
                  :item-data="item"
                  @del="delItem"
                />
              </draggable>
              <a-button
                class="add-clue-item-btn"
                @click="add"
              >
                <i
                  class="icon iconfont iconicon-test10"
                />

                {{ $t('message["1354"]') }}
              </a-button>
            </div>
            <div class="follow-time-set follow-invalid-set">
              <a-form-item
                v-if="datas.invalid_config.type && datas.invalid_config.type* 1 === 1"
                label="无效处理"
              >
                符合线索无效条件后 <a-input-number
                  v-decorator="[ 'invalid_config.day', { initialValue: datas.invalid_config.day }]"
                  :min="0"
                  :max="365"
                  class="ant-input-number-tip"
                  @change="handleChange2($event, 'day')"
                />
                天内，未转为信息，则将线索
                <a-radio-group
                  v-model="datas.invalid_config.status"
                  name="radioGroup"
                >
                  <a-radio :value="-1">
                    修改为无效
                  </a-radio>
                  <a-radio :value="-2">
                    标记为疑似无效
                  </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                v-if="datas.invalid_config.type && datas.invalid_config.type* 1 === 2"
                label="无效处理"
              >
                累计跟进 <a-input-number
                  v-decorator="[ 'invalid_config.number', { initialValue: datas.invalid_config.number }]"
                  :min="0"
                  :max="365"
                  @change="handleChange2($event, 'number')"
                /> 次后，
                <a-input-number
                  v-decorator="[ 'invalid_config.day', { initialValue: datas.invalid_config.day }]"
                  :min="0"
                  :max="365"
                  class="ant-input-number-tip"
                  @change="handleChange2($event, 'day')"
                />
                天内，未转为信息，则将线索
                <a-radio-group
                  v-model="datas.invalid_config.status"
                  name="radioGroup"
                >
                  <a-radio :value="-1">
                    修改为无效
                  </a-radio>
                  <a-radio :value="-2">
                    标记为疑似无效
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
          </div>
          <!-- <div class="clue-item-box">
            <h2 class="clue-item-tit">
              线索跟进
            </h2>
            <div class="clue-item-con">
              <follow-item
                v-for="item in datas['followup_field']"
                :key="item.fieldkey + (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime()"
                :item-data="item"
              />
            </div>
          </div> -->

          <div
            ref="footerBtn"
            class="footer-wrap"
          >
            <div
              ref="footer"
              class="footer"
              :class="{'ani':isShowBtn}"
            >
              <a-button
                type="primary"
                html-type="submit"
                :loading="submitting"
              >
                {{ $t('message["21"]') }}
              </a-button>
              <span class="sub-tip">{{ $t('message["22"]') }}？</span>
            </div>
          </div>
        </a-form>
      </div>
    </template>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import { mapState, mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
import FormItem from './clue/FormItem'
// import FollowItem from './clue/FollowItem'
export default {
  components: {
    CrumbTit,
    FormItem
  },
  data () {
    return {
      submitting: false,
      status: 1,
      isShowBtn: false,
      counter: 1,
      form: this.$form.createForm(this)
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('config/clue', ['datas', 'loadingContent', 'teamDatas', 'configFields']),
    teamValue () {
      const { datas = {} } = this
      let arr = []
      if (datas['dev_roleid']) {
        arr.push(datas['dev_roleid'])
      }
      if (datas['dev_groupid']) {
        arr.push(datas['dev_groupid'])
      }
      if (datas['dev_userid']) {
        arr.push(datas['dev_userid'])
      }
      return arr
    },
    isOpen () {
      return this.datas.isopen
    }
  },
  inject: ['reload'],
  watch: {
    datasReady (val) {
      if (val) {
        this.setFooterStyle()
      }
    },
    datas: {
      handler (val) {
        this.counter++
        if (val && this.counter > 2) {
          if (val.isopen * 1 === 0) {
            this.isShowBtn = false
          } else {
            this.isShowBtn = true
          }
          this.setFooterStyle()
        }
      },
      deep: true
    },
    isOpen (val) {
      this.isShowBtn = false
    }
  },
  async mounted () {
  },
  async created () {
    const chain = await this.fetchClueCofigData()
    chain
      .onSuccess(() => {})
      .fetch()
    await this.getAuthTeamInfo()
    const res = await this.fetchClueCofigFieldsData()
    res.onSuccess(raw => {
      document.title = '线索配置' + this.$t('message["1008"]') + ' - ' + this.baseinfo.projectname + '-' + this.baseinfo.comname
    }).fetch()
    // this.form = this.$form.createForm(this)
    this.setFooterStyle()
    window.addEventListener('resize', this.setFooterStyle)
    document.addEventListener('scroll', this.setFooterStyle)
  },
  methods: {
    ...mapActions('config/clue', ['fetchClueCofigData', 'getAuthTeamInfo', 'fetchClueCofigFieldsData', 'subClueCofigData', 'setClueOpenClose']),
    getLang,
    async saveForm () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.submitting = true
          const chain = await this.subClueCofigData()
          chain.params(this.datas)
            .onSuccess(async () => {
              this.$message.success(this.$t('message["1009"]'))
              this.reload()
            })
            .onNetSuccess((res) => {
              this.submitting = false
              // if (res.data.error) {
              //   this.$message.warning(res.data.message || res.data.payload[0].message)
              // }
            })
            .fetch()
        }
      })
    },
    handleChange2 (e, filedkey) {
      this.datas.invalid_config[filedkey] = e
    },
    handleChange (val, item) {
      this.datas['dev_userid'] = 0
      this.datas['dev_roleid'] = 0
      this.datas['dev_groupid'] = 0
      item && item.forEach(item2 => {
        this.datas['dev_' + item2.keyname] = item2.id
      })
    },
    async openHandle (e) {
      const val = e ? 1 : 0
      const chain = await this.setClueOpenClose()
      chain.params({ isopen: val })
        .onSuccess(raw => {
          this.datas.isopen = val
          this.reload()
        })
        .fetch()
    },
    fieldHanle () {},
    add () {
      this.datas['followup_field'].push({
        fieldkey: '',
        fieldname: '',
        follow: { cycle: 5, number: 3, invalid: 0 },
        parentkey: '',
        fieldtype: ''
      })
      this.datas['invalid_config'].type = 1
    },
    delItem (index) {
      this.datas['followup_field'].splice(index, 1)
      if (this.datas['followup_field'].length === 0) {
        this.datas['invalid_config'].type = 2
      }
    },
    getAssgin (val) {
      this.datas.assign = val.target.value
      this.form.validateFields(['userid'], { force: true }, (errors, values) => {
        // ...
      })
    },
    getTime (obj, val) {
      this.datas.sendtime = val
    },
    setFooterStyle () {
      this.$nextTick(() => {
        if (!this.$refs.footer) return

        const $footer = this.$refs.footer

        $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        // console.log(getScrollTop(), $footer.parentNode, $footer.parentNode.offsetTop)
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        // console.log(sectionWidth, pageWidth, $footer.parentNode.offsetLeft)
        if ($footer.parentNode.offsetTop - this.$getScrollTop() - window.innerHeight + $footer.parentNode.offsetHeight + 44 < 0) {
          $footer.style.position = 'relative'
          $footer.style.left = 0
        } else {
          $footer.style.position = 'fixed'
          $footer.style.left = pageWidth <= sectionWidth ? $footer.parentNode.offsetLeft + 1 + 'px' : $footer.parentNode.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped >
.visit-box::v-deep {
  padding: 0 0 24px;
  .clue-alert {
    padding: 24px 0 24px;
     position: relative;
     .ant-alert-message {
       font-weight: bold;
       font-size: 14px;
     }
     .ant-alert-description {
       color: #666;
       line-height: 24px;
     }
     .clue-switch{
        position: absolute;
        right: 24px;
        top: 29px;
      }
      .open-txt {
        margin-left: 8px;
      }
      &.clue-alert2{
        padding-top: 0;
        margin-top: -20px;
        .ant-alert-description{
          color: #333;
          position: relative;
          padding-left: 31px;
          .iconfont{
            color: #4CA0F2;
            font-size: 14px;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
  }
  .clue-distribute {
    .ant-radio-wrapper {
    display: block;
    line-height: 32px;
    .ant-form-item {
      display: inline-block;
    }
    &:first-child {
      margin-bottom: 16px;
    }
  }
  }
  .clue-item-tit {
    height: 48px;
    line-height: 48px;
    font-weight: 700;
    font-size: 18px;
    border-top: 1px solid #ebebeb;
    margin-bottom: 24px;
  }
  .clue-item-con {
    margin-left: 40px;
    .iconicon-test72 {
      font-size: 22px;
      cursor: move;
      color: #ccc;
      vertical-align: middle;
      margin-right: 8px;
      margin-left: -30px;
    }
    &.clue-fields-set-box{
      padding-left: 30px;
      border-bottom: 1px solid #ebebeb;

    }
  }
  .set-clue-item {
    margin-top: -16px;
    .ant-form-item-control {
      margin-bottom: -16px;
    }
    .add-clue-item-btn {
      margin-bottom: 24px;
      i{
        color: #ccc;
        margin-right: 4px;
      }
    }
  }
  .follow-time-set {
    border-bottom: 1px solid #ebebeb;
    margin-bottom: 24px;
    padding-left: 40px;
    .ant-form-item-label{
      float: left;
      margin-right: 16px;
    }
    .ant-form-item-control-wrapper {
      float: left;
    }
  &.follow-invalid-set{
    border: none;
    margin-top: 24px;
    .ant-input-number{
      width: 150px;
    }
    .ant-radio-group{
      margin-left: 20px;
      span.ant-radio + *{
        padding-left: 0;
      }
    }
     .ant-input-number-tip{
      position: relative;
      &::after{
        content: '设为0表示不处理';
        position: absolute;
        left: 0;
        top: 32px;
        color: #666;
        font-size: 12px;
      }
    }
  }
  }
}
.footer-wrap {
    height: 64px;
    margin-top: 40px;
  }
  .footer {
    position: fixed;
    bottom: -89px;
    left: 0;
    z-index: 999;
    height: 64px;
    margin-left: -40px;
    padding: 16px 80px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    transition: bottom 0.5s linear;
     .ant-btn {
        margin-right: 0 ;
      }
    span.sub-tip {
      color: #b3b3b3;
      margin-left: 10px;
    }
    // transform: translateY(100%)
  opacity: 0;
  }
  .ani {
    bottom: 0;
    opacity: 1;
  }
</style>
